import { messagesService } from '@/services';

const state = {
    notifications: [],
    notificationsStatus: false,
};

const actions = {
    getPushNotifications({ dispatch, commit }, data) {
        const { userId, limit, offset} = data;
        commit('notificationsState', {status: 'pending', notifications: []});

        messagesService.fetchPushNotifications(userId, limit, offset)
          .then(
            notifications => {
                commit('notificationsState', {status: 'success', notifications: notifications});
            },
            error => {
                commit('notificationsState', {status: 'success', notifications: []});
                dispatch('alert/error', error, { root: true });
            }
          );
    },
};

const mutations = {
    notificationsState(state, status) {
        state.notificationsStatus = status.status;
        state.notifications = status.notifications;
    },
}

export const messages = {
    namespaced: true,
    state,
    actions,
    mutations
};
